import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const SeavProtocol: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '32px',
      height: '32px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path d="M25.331 21.334V28.0034" stroke="#B4EB56" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22.6641 24.0018L25.3318 21.334"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0037 24.0018L25.3359 21.334"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99219 16.7988V25.8693C3.99371 27.0477 6.381 28.0035 9.32774 28.0035C12.2745 28.0035 14.6618 27.0477 14.6633 25.8693V16.7988"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6618 16.8002C14.6618 17.9786 12.273 18.9345 9.32622 18.9345C6.37948 18.9345 3.99219 17.9786 3.99219 16.8002C3.99219 15.6203 6.38252 14.666 9.32774 14.666C12.273 14.666 14.6618 15.6218 14.6633 16.8002"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99219 21.334C3.99219 22.5124 6.37948 23.4682 9.32622 23.4682C12.273 23.4682 14.6618 22.5124 14.6618 21.334"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3359 11.3326L20.0026 11.3327"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6641 8.6666L19.9974 8.66673"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3359 14.0006L20.0026 14.0007"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11.3333V7.41176C12 6.63207 12.597 6 13.3333 6H17.3333H21.3333C22.0697 6 22.6667 6.63207 22.6667 7.41176V15.9216C22.6667 16.7013 22.0697 17.3333 21.3333 17.3333H18"
      stroke="#B4EB56"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const SeavProtocolDark: FC<SvgIconProps> = ({ sx, ...props }) => (
  <SvgIcon
    viewBox="0 0 32 32"
    sx={{
      width: '24px',
      height: '24px',
      fill: 'none',
      color: '#B4EB56',
      ...sx,
    }}
    {...props}
  >
    <path d="M25.331 21.334V28.0034" stroke="#090C18" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M22.6641 24.0018L25.3318 21.334"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.0037 24.0018L25.3359 21.334"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99219 16.7988V25.8693C3.99371 27.0477 6.381 28.0035 9.32774 28.0035C12.2745 28.0035 14.6618 27.0477 14.6633 25.8693V16.7988"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6618 16.8002C14.6618 17.9786 12.273 18.9345 9.32622 18.9345C6.37948 18.9345 3.99219 17.9786 3.99219 16.8002C3.99219 15.6203 6.38252 14.666 9.32774 14.666C12.273 14.666 14.6618 15.6218 14.6633 16.8002"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99219 21.334C3.99219 22.5124 6.37948 23.4682 9.32622 23.4682C12.273 23.4682 14.6618 22.5124 14.6618 21.334"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3359 11.3326L20.0026 11.3327"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6641 8.6666L19.9974 8.66673"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.3359 14.0006L20.0026 14.0007"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 11.3333V7.41176C12 6.63207 12.597 6 13.3333 6H17.3333H21.3333C22.0697 6 22.6667 6.63207 22.6667 7.41176V15.9216C22.6667 16.7013 22.0697 17.3333 21.3333 17.3333H18"
      stroke="#090C18"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
